import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Capability } from 'shared/src/lib/capability-carousel';
import { BenefitsService } from 'shared/src/lib/common-pages/onboarding/benefits.service';
import { VideoJsPlayerOptions } from 'video.js';
import { environment } from '@environments/environment';

@Component({
  selector: 'deloitteai--onboarding-page',
  templateUrl: './onboarding.html',
  styleUrls: ['./onboarding.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class OnboardingPage implements OnInit {
  @ViewChild('questionaire', { read: ElementRef, static: true })
  private questionaire: ElementRef;

  videoOptions: VideoJsPlayerOptions = {
    autoplay: false,
    fluid: true,
    html5: true,
    poster: 'assets/img/video-cover@2x.png',
    muted: false,
    sources: [
      {
        src: environment.onboarding.video_url,
        type: 'video/mp4',
      },
    ],
  };

  benefits: Capability[];

  backendDevelopmentUrl = environment.onboarding.development.backend_url;
  frontendDevelopmentUrl = environment.onboarding.development.frontend_url;
  businessSupportEmailAddress =
    environment.onboarding.development.business_support_email;
  startQuestionnaireUrl = environment.aoh_url;
  visitAssetOwnerHubUrl = environment.aoh_url + '/start';
  displayVideo = environment.onboarding.displayVideo;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  scrollTo($event: MouseEvent, target: string): void {
    $event.preventDefault();
    $event.stopPropagation();

    const offset = (
      this.questionaire.nativeElement as HTMLElement
    ).getBoundingClientRect();
    window.scroll({ top: offset.y - 70, left: 0 });
  }

  constructor(private readonly benefitsService: BenefitsService) {}

  ngOnInit(): void {
    this.benefitsService.init();
    this.benefitsService.benefits$.subscribe(
      (benefits) => (this.benefits = benefits),
    );
  }
}
